import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-twitter-reviews',
  templateUrl: './twitter-reviews.component.html',
  styleUrls: ['./twitter-reviews.component.scss']
})
export class TwitterReviewsComponent implements OnInit {
  total_txn: number = 0;
  transactions: any;
  private modalRef;

  constructor(
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    // this.deduct_credits_transactions();
    this.vip_token_transactions();
  }

  deduct_credits_transactions() {
    let formData = new FormData();
    formData.append('type', '3');

    this.auth.deduct_credits_transactions(formData).subscribe((response: any) => {
      this.transactions = response.body;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe((response: any) => {
      this.transactions = response.body.transactions;
      this.total_txn = response.body.available;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
  
  deduct_credits(credits,toshow) {
    Swal.fire({
      title: 'Are you sure?',
      text: `${credits} credits will be deducted from your VIP Tokens.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, deduct it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let formData = new FormData();
        formData.append('tokens', credits);
        formData.append('type', '4');
        formData.append('toshow', toshow);
        formData.append('reviews', '0');

        this.auth.deduct_credits(formData).subscribe((response: any) => {
          this.total_txn = response.body;
          Swal.fire(
            'Done!',
            response.message,
            'success'
          );
          
        }, (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin'])
          }

          Swal.fire(
            'Warning!',
            error.error.message,
            'warning'
          );
        });
      }
    })
  }

  view_all_transactions(modal) {
    this.modalRef = this.modalService.open(modal, { size: 'md', ariaLabelledBy: 'modal-basic-title' });
  }

}
